module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAK5JREFUOBG1VEEOgCAMI77DP/EI/n/3JHYIycQ5ilESMra1lYIhhDpyzmtbz8YbF4WIuWGmF2KpcmPhIllrASHvmLSoYCsHoWzodNk1KNEhZwhQZ0FjGSCDUd8OwSN4vYtIn1hEq9bz3NwQkMuSQV2aKQ6y/i0oscVU+qPY7U5svrdsiIl1bZ8/R4/o9cxTYggMpojTQKCH2CHA8PPIQeOX5+u7B7a5kZ229WzU3AORpUp7hF/TTgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/close_icon_10_10.png
// module id = ./src/_asset/sources/assets/images/close_icon_10_10.png
// module chunks = main